// extracted by mini-css-extract-plugin
module.exports =  {"pagination":"pagination--LVswC","custom-bg":"custom-bg--gKYxt","customBg":"custom-bg--gKYxt"};